import { render, staticRenderFns } from "./FormsChangelogComponent.vue?vue&type=template&id=7526adbe&"
import script from "./FormsChangelogComponent.vue?vue&type=script&lang=js&"
export * from "./FormsChangelogComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports